<script>
import Tooltip from '@/components/v3/base/Tooltip';

export default {
  name: 'NavigatorName',
  components: { Tooltip },
  props: {
    text: {
      type: String,
      default: '',
    },

    customClass: {
      type: String,
      default: '',
    },

    tooltipWidth: {
      type: [String, Number],
      default: 300,
    },

    tooltipClass: {
      type: String,
      default: '',
    },

    widthAuto: Boolean,
  },

  data() {
    return {
      loading: true,
      isOver: false,
      isOpen: false,
      loading2: false,
      nameContent: null,
      w: 'auto',
      posX: 0,
      posY: 0,
    };
  },

  computed: {
    customPosition() {
      return { left: `${this.posX}px`, top: `${this.posY}px` };
    },
  },

  mounted() {
    this.setupWidth();
  },

  methods: {
    checkTextOver() {
      this.loading = true;
      this.isOver = false;
      if (
        this.nameContent &&
        this.nameContent.scrollWidth > this.nameContent.clientWidth
      ) {
        this.isOver = true;
      }
      this.loading = false;
      this.loading2 = false;
    },

    onMouseLeave() {
      this.isOpen = false;
    },

    setupWidth() {
      this.w = 'auto';
      this.$nextTick(() => {
        this.w = `${this.nameContent?.clientWidth}px`;
        if (this.w === '0px') {
          this.w = 'auto';
        }
        this.$nextTick(() => {
          this.loading2 = true;
          this.$nextTick(() => {
            this.checkTextOver();
          });
        });
      });
    },

    getSelectedPosition(e) {
      this.posX = e.x + 30;
      this.posY = e.y + 30;
    },

    onMouseOver(e) {
      this.getSelectedPosition(e);
      this.isOpen = true;
    },
  },
};
</script>
<template>
  <div
    class="tw-w-full tw-relative tw-z-10 hover:tw-z-20"
    :class="[customClass]"
    :style="{ maxWidth: w }"
  >
    <div
      ref="nameContent"
      class="tw-w-full"
      :class="{
        'tw-truncate tw-whitespace-nowrap': !loading,
        'tw-whitespace-nowrap': loading2,
      }"
      @mouseover="onMouseOver"
      @mouseleave="onMouseLeave"
    >
      {{ text }}
    </div>
    <div v-if="isOver" class="tw-fixed tw-z-10" :style="customPosition">
      <Tooltip
        v-model="isOpen"
        :width="tooltipWidth"
        :widthAuto="widthAuto"
        :class="tooltipClass"
      >
        {{ text }}
      </Tooltip>
    </div>
  </div>
</template>
